import { jsx as _jsx } from "react/jsx-runtime";
const React = require("react");
import { isActivePath } from "../../../Shared/utils/browser";
import { Link } from "../../custom_components/components/library/link";
const menuLink = (x, handle)=>x.external ? /*#__PURE__*/ _jsx("a", {
        className: `menu__link ${isActivePath(x.relative) ? 'menu__link--active' : ''}`,
        href: x.absolute,
        target: "_blank",
        rel: "noopener noreferrer",
        onClick: handle,
        children: x.title
    }, x.key) : /*#__PURE__*/ _jsx(Link, {
        url: x.relative,
        handle: handle,
        className: `menu__link ${isActivePath(x.relative) ? 'menu__link--active' : ''}`,
        children: x.title
    }, x.key);
export default menuLink;
